"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _cardModule = _interopRequireDefault(require("./card.module.css"));

const Card = _ref => {
  let {
    className,
    square,
    disabled,
    style,
    children,
    isElevated
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(_cardModule.default.card, className, square && _cardModule.default.square, disabled && _cardModule.default.disabled, isElevated && _cardModule.default.isElevated),
    style: style
  }, children);
};

Card.defaultProps = {
  className: '',
  style: {},
  square: false,
  disabled: false,
  isElevated: false
};
Card.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  square: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  isElevated: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]) // eslint-disable-line

};
var _default = Card;
exports.default = _default;